import ApiService from './api.service.js'
// import { async } from 'q'
import { VMenu } from 'vuetify/lib'
import { isConstructorDeclaration } from 'typescript'

const AccountInventoryService = {

  getAllAccounts: async function (params, callback) {
    try {
      let reqParams = {
        params: {
          action: 'list',
          orderBy: 'Onboarding_Id',
          order: 'DESC',
          size: 10,
          filters: JSON.stringify(params.filters),
          nextPaginationKey: params.nextPaginationKey
        }
      }
      // console.log(process.env.VUE_APP_ACCINVENTORY_ACCOUNTS)
      // debugger
      let response = await ApiService.get(process.env.VUE_APP_ACCINVENTORY_ACCOUNTS, reqParams)
      callback(response.data)
      
    } catch (error) {

      console.log('API ERROR', error)
    }
  },


  getNumberOfAccountsByCustomer: async function (params, callback) {
    try {
      let reqParams = {
        params: {
          action: 'list-customers'
        }
      }
      let response = await ApiService.get(process.env.VUE_APP_ACCINVENTORY_ACCOUNTS, reqParams)
      callback(response.data)
      
    } catch (error) {

      console.log('API ERROR', error)
    }
  },


  downloadAccounts: async function (params, callback) {
    try {
      let reqParams = {
        params: {
          action: 'download',
          filters: JSON.stringify(params.filters)
        }
      }
      
      let response = await ApiService.get(process.env.VUE_APP_ACCINVENTORY_ACCOUNTS, reqParams)
      callback(response.data)
      
    } catch (error) {

      console.log('API ERROR', error)
    }
  },


  getAllMasterpayers: async function (params, callback) {
    try {
      let reqParams = {
        params: {
          action: 'list-mp'
        }
      }

      let response = await ApiService.get(process.env.VUE_APP_ACCINVENTORY_ACCOUNTS, reqParams)
      callback(response.data)
      
    } catch (error) {

      console.log('API ERROR', error)
    }
  },

  initAccountData: async function () {
    try {
      let reqParams = {
        params: {
          action: 'list'
        }
      }
      let response = await ApiService.get(process.env.VUE_APP_ACCINVENTORY_REPORT_API, reqParams)
      return this._prepData(response.data.accounts, response.data.masterpayers, response.data.pods)

    } catch (error) {
      vm.$store.commit('setLoader', { loading: false }, { root: true })
      throw new Error('Error:' + error)
      
    }
  },

  initMPayers: async function (callback) {
    try {
      let mpParams = {
        params: {
          action: 'master-payer'
        }
      }
      let mpResponse = await ApiService.get(process.env.VUE_APP_ACCINVENTORY_API, mpParams)
      if (callback === undefined) return mpResponse.data
      callback(mpResponse.data)
    } catch (error) {
      vm.$store.commit('setLoader', { loading: false }, { root: true })
    }
  },

  _prepData (accounts, masterPayers, podList) {
    // lets add agreement type per account
    let masterAccounts = accounts.map(account => {
      let masterPayer = masterPayers.find(mp => {
        return mp.Master_Id === account.Master_Id
      })
      if (masterPayer !== undefined && masterPayer.Agreement !== undefined) {
        let agreementType = masterPayer.Agreement.toLowerCase()
        account['agreement'] = agreementType
        return account
      }
    })

    return {
      masterAccounts: masterAccounts,
      masterPayers: masterPayers,
      pods: podList
    }
  },

  refreshData: async function () {
    return this.initAccountData()
  },
  
  flagAccount: async function (data, callback) {
    try {
      let reqParams = {
        action: 'onboarding',
        Onboarding_Id: data.Onboarding_Id,
        Del_Flag: '1'
      }
      let res = await ApiService.put(process.env.VUE_APP_ACCINVENTORY_API, reqParams)
      callback(res)
    } catch (error) {
      throw new Error('Error:' + error)
    }
  },

  // REVIEW EMAIL GET METHOD
  getEmailTemplate: async function (emailTemplate, callback) {
    try {
      console.log('look for update')
      console.log(emailTemplate)
      let reqData = {
        params: {
          action: 'external',
          send_to: emailTemplate.recipients,
          oppreg_id: emailTemplate.oppreg_id,
          template: emailTemplate.template,
          OppReg_Status: emailTemplate.OppReg_Status,
          Workload_Title: emailTemplate.Workload_Title,
          Workload_Status: emailTemplate.oppreg_status,
          AWS_SalesRep_Name: emailTemplate.sales_rep_name,
          AWS_SalesRep_eMail: emailTemplate.sales_rep_email,
          AWS_Notes: emailTemplate.note,
          oppOwnerEmail: emailTemplate.oppOwnerEmail,
          oppOwnerName: emailTemplate.oppOwnerName,
          oppRegId: emailTemplate.oppRegId
        }
      }
      console.log(reqData)
      let res = await ApiService.get(process.env.VUE_APP_GALAXY_MAIL_SERVER_API, reqData)
      callback(res.data)
    } catch (error) {
      throw new Error('Error:' + error)
    }
  },
  // SEND EMAIL TEMPLATE POST METHOD
  postEmailTemplate: async function (emailTemplate, callback) {
    try {
      let reqData = {
        action: 'external',
        send_to: emailTemplate.recipients,
        oppreg_id: emailTemplate.oppreg_id,
        template: emailTemplate.template,
        OppReg_Status: emailTemplate.OppReg_Status,
        Workload_Title: emailTemplate.Workload_Title,
        Workload_Status: emailTemplate.oppreg_status,
        AWS_SalesRep_Name: emailTemplate.sales_rep_name,
        AWS_SalesRep_eMail: emailTemplate.sales_rep_email,
        AWS_Notes: emailTemplate.note,
        oppOwnerEmail: emailTemplate.oppOwnerEmail,
        oppOwnerName: emailTemplate.oppOwnerName,
        oppRegId: emailTemplate.oppRegId
      }

      if (emailTemplate.isSubjectChanged) {
        reqData['emailSubjectType'] = emailTemplate.emailSubjectType
      }
      if (emailTemplate.isTemplateChanged) {
        reqData['templateEmail'] = this.convertToHtmlEntities(emailTemplate.templateEmail)
      }

      let res = await ApiService.post(process.env.VUE_APP_GALAXY_MAIL_SERVER_API, reqData)
    } catch (error) {
      throw new Error('Error:' + error)
    }
  },

  // SAVE NOTES
  postNotes: async function (emailTemplate, callback) {
    try {
      // POST NOTES WITH PROJECT ID
      let saveNotes = {
        action: 'aws-info',
        Project_Id: vm.$route.params.id
      }

      let res = await ApiService.post(process.env.VUE_APP_OPPREG_API, saveNotes)
    } catch (error) {
      throw new Error('Error:' + error)
    }
  },

  getMasterPayerSubAccounts: async function (mpId, callback) {
    try {
      // let res = await ApiService.get(`/account-inventory?MP_ID=${mpId}&IS_MP=No`)
      let reqData = {
        params: {
          action: 'list',
          MP_ID: mpId
        }
      }
      let res = await ApiService.get(process.env.VUE_APP_ACCINVENTORY_REPORT_API, reqData)
      if (res.data.length) {
        // get accounts where is-mp flag is set to value "No"
        let subAccounts = res.data.filter(account => account['Is_MP'] === 'No')
        callback(subAccounts)
      }
    } catch (error) {
      throw new Error('Error:' + error)
    }
  },

  // GET CUSTOMER WHERE ROUTE ID IS EQUAL TO MASTERPAYER ID
  getCustomersById: async function (extId, callback) {
    try {
      console.log(':: GET CUSTOMER BY ID ::')
      console.log(extId)
      let reqData = {
        params: {
          action: 'list',
          customer_name: extId
        }
      }
      let res = await ApiService.get(process.env.VUE_APP_ACCINVENTORY_REPORT_API, reqData)
      callback(res.data)
    } catch (error) {
      vm.$store.commit('setLoader', { loading: false }, { root: true })
    }
  },

  // UPDATE CUSTOMER WHERE ACCOUNT_ID
  updateCustomer: async function (data, callback) {
    try {
      let reqData = {
        action: 'update',
        ...data
      }
      let res = await ApiService.put(process.env.VUE_APP_ACCINVENTORY_REPORT_API, reqData)
      callback(res)
    } catch (error) {
      vm.$store.commit('setLoader', { loading: false }, { root: true })
    }
  },
  saveNewAccount: async function (data, callback) {
    let responses = {
      aggrement: null,
      financial: null,
      expiration: null,
      security: null,
      onboarding: null,
      external: null
    }

    try {
      console.log('onboard new account', data)
      let onboardingReqBody = {
        action: 'onboard',
        Acct_ID: data.Acct_ID,
        Customer_Id: data.Customer_Id,
        Acct_name: data.Acct_name,
        Acct_Status: data.Acct_Status ? data.Acct_Status: 'New',
        Acct_DL: data.Acct_DL,
        Acct_Alias_Group: data.Acct_Alias_Group,
        Date_onboarded: data.Date_onboarded,
        Last_Date_Validated: data.Last_Date_Validated,
        Date_Requested_change: data.Date_Requested_change,
        MP_ID: data.Master_Id,
        Previous_MP_ID: data.Previous_MP_ID,
        Managed_Svc: data.Managed_Svc,
        Comments: data.Comments,
        Acct_Offering_Stat: data.Acct_Offering_Stat,
        Is_MP: data.Is_MP ? 'Yes' : 'No',
        Acct_Restricted: data.Acct_Restricted ? 'Yes' : 'No',
        Acct_Description: data.Acct_Description,
        Customer_Type: data.Customer_Type,
        WBS_code: data.WBS_code,
        WBS_expiration_date: data.WBS_expiration_date,
        IWO_Reqd: data.IWO_Reqd,
        IWO_Code: data.IWO_Code,
        IWO_expiration_date: data.IWO_expiration_date,
        Credit_amount: data.Credit_amount,
        Account_expire_on_credits: data.Account_expire_on_credits,
        End_date: data.End_date,
        Account_expire_on_end_date: data.Account_expire_on_end_date,
        R_Code: data.R_Code,
        DXC_discount: data.DXC_discount,
        DXC_uplift: data.DXC_uplift,
        Client_discount: data.Client_discount,
        Client_uplift: data.Client_uplift,
        Contract_description: data.Contract_description,
        Account_notes: data.Account_notes,
        MFA: data.MFA,
        Root_Credential_Store: data.Root_Credential_Store, 
        Onboard_Date_Lock: data.Onboard_Date_Lock,
        Notification_List: JSON.stringify(data.Notification_List),
        IAM_Users: JSON.stringify(data.IAM_Users),
        Financial_Owner: JSON.stringify(data.Financial_Owner),
        GovCloud_Resource_Account: data.GovCloud_Resource_Account
      }
      responses.onboarding = await ApiService.post(process.env.VUE_APP_ACCINVENTORY_API, onboardingReqBody)
      callback(responses)
    } catch (error) {
      throw new Error('Error:' + error)
    }
  },
  updateAccount: async function (data, callback) {
    try {

      let pod_id = data.Managed_Svc === 'DXC Gold' ?  data.POD_Id : ""
      let reqData = {
        action: 'update',
        ...data,
        MP_ID: data.Master_Id,
        Is_MP: data.Is_MP === 'Yes' ? 'Yes' : 'No',
        Acct_Restricted: data.Acct_Restricted === 'Yes' ? 'Yes' : 'No',
        POD_Id: pod_id,
        Account_Owners: JSON.stringify(data.Account_Owners),
        Notification_List: JSON.stringify(data.Notification_List),
        IAM_Users: JSON.stringify(data.IAM_Users),
        Financial_Owner: JSON.stringify(data.Financial_Owner),
        Account_Owners: JSON.stringify(data.Account_Owners)
      }

      console.log('update account req data', reqData)

      let res = await ApiService.put(process.env.VUE_APP_ACCINVENTORY_REPORT_API, reqData)
      callback(res)
    } catch (error) {
      throw new Error('Error:' + error)
    }
  },


  updateAccountAWSAPNData: async function(data, callback) {
    let reqData = {
      action: 'update-aws-apn-tab',
      ...data
    }

    let res = await ApiService.put(process.env.VUE_APP_ACCINVENTORY_REPORT_API, reqData)
    if (res) {
      callback(res)
    }

  },

  searchCustomers: async function (data, callback) {
    try {
      let reqParams = {
        params: {
          action: 'customer-regions',
          Customer_Name: data
        }
      }
      let customerRes = await ApiService.get(process.env.VUE_APP_SEARCH_CUSTOMERS_API, reqParams)
      callback(customerRes.data)
    } catch (error) {
      vm.$store.commit('setCustomerSearchLoading', false)
    }
  },
  checkIfAccountIdIsAvailable: async function (id, callback) {
    try {
      let reqParams = {
        params: {
          action: 'onboarding',
          Acct_ID: id
        }
      }
      let onboardingResponse = await ApiService.get(process.env.VUE_APP_ACCINVENTORY_API, reqParams)
      if (onboardingResponse.data.length) {
        callback(null, { acctExist: true, data: onboardingResponse.data })
      } else {
        // eslint-disable-next-line standard/no-callback-literal
        callback(null, {acctExist: false, data: onboardingResponse.data })
      }
    } catch (error) {
      vm.$store.commit('setAccountIdExistLoading', false)
    }
  },

  checkIfOpportunityNumberIsAvailable: async function (id, callback) {
    try {
      let reqParams = {
        params: {
          action: 'opportunity-number',
          ACE_Opportunity_Number: id
        }
      }
      let onboardingResponse = await ApiService.get(process.env.VUE_APP_ACCINVENTORY_API, reqParams)
      console.log(onboardingResponse)
      if (onboardingResponse.data.id) {
        callback(null, { opportunityNumberExist: true, data: onboardingResponse.data })
      } else {
        // eslint-disable-next-line standard/no-callback-literal
        callback(null, { opportunityNumberExist: false, data: onboardingResponse.data })
      }
    } catch (error) {
      vm.$store.commit('admin/setAceOppNumExistLoading', false)
    }
  },


  checkIfMpIdExist: async function (id, callback) {
    try {
      let reqParams = {
        params: {
          action: 'master-payer',
          MP_ID: id
        }
      }
      let masterPayerResponse = await ApiService.get(process.env.VUE_APP_ACCINVENTORY_API, reqParams)
      if (masterPayerResponse.data.length) {
        // eslint-disable-next-line standard/no-callback-literal
        callback({ mpIdExist: true, record: masterPayerResponse.data[0] })
      } else {
        // eslint-disable-next-line standard/no-callback-literal
        // error
        callback(null, true)
      }
    } catch (error) {

    }
  },
  submitMultipleAccounts: async function (id, updateDate, callback) {
    try {
      let reqData = {
        action: 'date_validated',
        Acct_IDs: id,
        Last_Date_Validated: updateDate
      }
      let lastDateResponse = await ApiService.put(process.env.VUE_APP_ACCINVENTORY_LAST_DATE_API, reqData)
      callback(lastDateResponse)
    } catch (error) {
      vm.$store.commit('setLastDateValidatedSaving', false)
    }
  },
  selectUnArchive: async function (id, callback) {
    try {
      let reqParams = {
        action: 'archive',
        Acct_IDs: id,
        Del_Flag: 0
      }
      let res = await ApiService.put(process.env.VUE_APP_ACCINVENTORY_LAST_DATE_API, reqParams)
      callback(res)
    } catch (error) {
      throw new Error('Error:' + error)
    }
  },
  saveNewMasterPayer: async function (data, callback) {
    try {
      let mpParams = {
        action: 'master-payer',
        MP_ID: data.MP_ID,
        Agreement: data.Agreement,
        AWS_Support_Type: data.AWS_Support_Type,
        Type: data.Type,
        MP_discount: data.MP_discount,
        MP_uplift: data.MP_uplift,
        MP_Business_Rules: data.MP_Business_Rules,
        MP_features: data.MP_features,
        MP_Type: data.MP_Type
      }
      let res = await ApiService.post(process.env.VUE_APP_ACCINVENTORY_API, mpParams)
      callback(res)
    } catch (error) {
      vm.$store.commit('setNewMasterPayerSaving', false)
    }
  },
  updateMPayers: async function (data, callback) {
    console.log(data)
    const jsonSyncConfig = JSON.stringify(data.Sync_Config)
    try {
      let mpParams = {
        action: 'master-payer',
        Master_Id: data.Master_Id,
        MP_ID: data.MP_ID,
        Agreement: data.Agreement,
        AWS_Support_Type: data.AWS_Support_Type,
        Type: data.Type,
        MP_discount: data.MP_discount,
        MP_uplift: data.MP_uplift,
        MP_Business_Rules: data.MP_Business_Rules,
        MP_features: data.MP_features,
        MP_Type: data.MP_Type,
        Grandfathered: data.Grandfathered,
        CT_Log_Usage: data.CT_Log_Usage,
        Sync_Config: jsonSyncConfig
      }
      let mpResponse = await ApiService.put(process.env.VUE_APP_ACCINVENTORY_API, mpParams)
      if (mpResponse.data) {
        callback(mpResponse.data)
      } else {
        callback(null, { error: 'Error Updating MasterPayer Account' })
      }
    } catch (error) {
      vm.$store.commit('setNewMasterPayerSaving', false)
    }
  },
  deleteMasterPayer: async function (id, callback) {
    try {
      let mpParams = {
        action: 'master-payer-del',
        Master_Id: id
      }
      let mpResponse = await ApiService.post(process.env.VUE_APP_ACCINVENTORY_API, mpParams)
      if (mpResponse.data) {
        callback(mpResponse.data)
      } else {
        callback(null, { error: 'Error Updating MasterPayer Account' })
      }
    } catch (error) {
      throw new Error('Error: ' + error)
    }
  },
  validateMasterPayerMPId: async function (mpId, callback) {
    try {
      let mpParams = {
        params: {
          action: 'master-payer',
          MP_ID: mpId
        }
      }
      let res = await ApiService.get(process.env.VUE_APP_ACCINVENTORY_API, mpParams)
      if (res.data.length > 0) {
        callback(null, { duplicateTitle: true })
      } else {
        callback(res.data)
      }
    } catch (error) {
      throw new Error('Error: ' + error)
    }
  },

  validateAccountDetails: async function (account, callback) {
    if (typeof account === 'object') {
      try {
        let request_data = {
          params: {
            id: account.Acct_ID, name: account.Acct_name, 
            email: account.Acct_DL, status: account.Acct_Status,
            mp_id: account.MP_ID, date_onboarded: account.Date_onboarded
          }
        }
        console.log('request_data: ', request_data)
        let res = await ApiService.get(process.env.VUE_APP_AWS_ORGANIZATION, request_data)
        callback(res.data)
      } catch (error) {
        callback(null)
      }
    
    } else {
      let request_data = {params: {mp_type: account}}
      ApiService.get(process.env.VUE_APP_AWS_ORGANIZATION, request_data)
    }

  },

  validateOppRegId: async function (id, callback) {
    try {
      let oppregParams = {
        params: {
          action: 'oppreg-project',
          SFDC_Id: id
        }
      }
      let oppregResponse = await ApiService.get(process.env.VUE_APP_REQUEST_AWS_ACCOUNT, oppregParams)
      callback(oppregResponse.data)
    } catch (error) {
    }
  },

  downloadMasterpayerActiveReport: async function(params, callback) {
    try {
      let reportParams = {
        params: {
          action: 'master-payer-list'
        }
      }
      let response = await ApiService.get(process.env.VUE_APP_ACCINVENTORY_REPORT_API, reportParams)
      window.open(response.data, "_self");
      // callback(reportLink)
    } catch (error) {
    }
  },

  downloadMasterpayerChildReport: async function(params, callback) {
    try {
      let reportParams = {
        params: {
          action: 'master-payer-child-account-list'
        }
      }
      let response = await ApiService.get(process.env.VUE_APP_ACCINVENTORY_REPORT_API, reportParams)
      // window.open(response.data, "_self");
      callback(response)
    } catch (error) {
      console.log('Error Downloading Report')
    }
  },
  convertToHtmlEntities (inputText) {
    return inputText.replace(/(?:\r\n|\r|\n)/g, '<br>')
  }
}

export default AccountInventoryService
